import React, { useState } from 'react';

export const NewCharCard = ({ theme, density, cardStyle, onClick }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};
  const [hovered, setHovered] = useState(false);
  const handleKeyDown = onClick
    ? (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          onClick();
        }
      }
    : undefined;

  return (
    <div
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? c.bgHover : 'rgba(0,0,0,0.15)',
        border: `1.5px dashed ${hovered ? c.accent : c.borderPrimary}`,
        borderRadius: e.borderRadius || '8px',
        padding: 14,
        cursor: onClick ? 'pointer' : 'default',
        transition: e.transition,
        minHeight: 140,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontFamily: t.fontFamily,
      }}
    >
      <div style={{
        fontSize: '1.9rem',
        marginBottom: 6,
        color: c.accent,
        filter: hovered ? `drop-shadow(0 0 12px ${c.accentGlow || c.accent + '88'})` : 'none',
        transition: e.transition,
      }}>✦</div>
      <div style={{
        fontFamily: t.headingFamily || 'Georgia, serif',
        color: c.textPrimary,
        fontWeight: 600,
        fontSize: '0.95rem',
      }}>New character</div>
      <div style={{ color: c.textMuted, fontSize: '0.72rem', fontStyle: 'italic', marginTop: 4 }}>
        or import sheet
      </div>
    </div>
  );
};
